import { supabase } from '../../lib/supabaseClient';

export type PhotoAlbum = {
  id: string;
  title_en: string;
  title_th: string | null;
  slug: string;
  sort_order: number;
  created_at?: string;
  updated_at?: string;
};

export type Photo = {
  id: string;
  photo_album_id: string;
  caption_en: string | null;
  caption_th: string | null;
  storage_path: string;
  sort_order: number;
  created_at?: string;
};

const BUCKET = 'photo_galleries';

export async function getPhotoAlbums() {
  const { data, error } = await supabase
    .from('photo_albums')
    .select('*')
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return (data ?? []) as PhotoAlbum[];
}

export async function getPhotoAlbum(id: string) {
  const { data, error } = await supabase.from('photo_albums').select('*').eq('id', id).single();
  if (error) throw error;
  return data as PhotoAlbum;
}

export async function getPhotos(albumId: string) {
  const { data, error } = await supabase
    .from('photos')
    .select('*')
    .eq('photo_album_id', albumId)
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return (data ?? []) as Photo[];
}

export async function createPhotoAlbum(payload: Partial<PhotoAlbum>) {
  const { data, error } = await supabase.from('photo_albums').insert(payload).select('id').single();
  if (error) throw error;
  return data.id as string;
}

export async function updatePhotoAlbum(id: string, payload: Partial<PhotoAlbum>) {
  const { error } = await supabase.from('photo_albums').update(payload).eq('id', id);
  if (error) throw error;
}

export async function deletePhotoAlbum(id: string) {
  const { error } = await supabase.from('photo_albums').delete().eq('id', id);
  if (error) throw error;
}

export async function createPhoto(payload: Partial<Photo>) {
  const { data, error } = await supabase.from('photos').insert(payload).select('id').single();
  if (error) throw error;
  return data.id as string;
}

export async function updatePhoto(id: string, payload: Partial<Photo>) {
  const { error } = await supabase.from('photos').update(payload).eq('id', id);
  if (error) throw error;
}

export async function deletePhoto(id: string) {
  const { error } = await supabase.from('photos').delete().eq('id', id);
  if (error) throw error;
}

export function getPhotoPublicUrl(path: string) {
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return data.publicUrl;
}

export async function uploadPhoto(albumSlug: string, file: File) {
  const uid = crypto.randomUUID();
  const ext = file.name.split('.').pop()?.toLowerCase() || 'jpg';
  const path = `${albumSlug}/${uid}.${ext}`;
  const { error } = await supabase.storage.from(BUCKET).upload(path, file, { upsert: false });
  if (error) throw error;
  return path;
}
